import type { Price } from '@tsTypes/api/Price';

type DiscountParts = Partial<Exclude<Price['discountParts'], unknown[]>>;

type PriceWithDiscountParts = {
  discountParts?: Price['discountParts'];
};

const hasFreeDelivery = (price?: PriceWithDiscountParts | null): boolean => {
  const discountParts = price?.discountParts as DiscountParts | undefined;

  return (discountParts?.FREE_DELIVERY ?? 0) > 0;
};

export default hasFreeDelivery;
